import { Controller } from "@hotwired/stimulus"
import { get, supported } from "@github/webauthn-json"

// Drives the WebAuthn authentication ceremony (login 2nd factor). Reads the
// server-generated assertion options, runs navigator.credentials.get() via the
// webauthn-json ponyfill, and POSTs the assertion back as JSON.
export default class extends Controller {
  static values = { options: Object, verifyUrl: String }
  static targets = ["status", "button"]

  connect() {
    if (!supported()) {
      this.disable("This browser doesn't support passkeys. Use a different device or browser.")
    }
  }

  async authenticate(event) {
    event.preventDefault()
    this.setStatus("Follow your device's prompt…")

    let assertion
    try {
      assertion = await get({ publicKey: this.optionsValue })
    } catch (error) {
      if (error.name === "NotAllowedError") {
        this.setStatus("Cancelled. Tap Use passkey to try again.", true)
      } else {
        this.setStatus("Couldn't use your passkey. Try again.", true)
      }
      return
    }

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.verifyUrlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": token, "Accept": "application/json" },
        body: JSON.stringify({ publicKeyCredential: assertion })
      })
      const data = await response.json().catch(() => ({}))
      if (response.ok) {
        window.Turbo.visit(data.redirect_to)
      } else {
        this.setStatus(data.error || "Verification failed. Try again.", true)
      }
    } catch {
      this.setStatus("Network error. Try again.", true)
    }
  }

  disable(message) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
    this.setStatus(message, true)
  }

  setStatus(text, isError = false) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text
    this.statusTarget.classList.toggle("text-red-600", isError)
    this.statusTarget.classList.toggle("text-gray-500", !isError)
  }
}
